var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseAsset = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.325,
    y: 0.325,
    width: 25.35,
    height: 25.35,
    rx: 12.675,
    fill: "#383838"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.325,
    y: 0.325,
    width: 25.35,
    height: 25.35,
    rx: 12.675,
    stroke: "#383838",
    strokeWidth: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0477 17.3119C18.096 17.3602 18.1343 17.4176 18.1604 17.4807C18.1866 17.5438 18.2 17.6115 18.2 17.6798C18.2 17.7481 18.1866 17.8158 18.1604 17.8789C18.1343 17.942 18.096 17.9994 18.0477 18.0477C17.9994 18.096 17.942 18.1343 17.8789 18.1604C17.8158 18.1866 17.7481 18.2 17.6798 18.2C17.6115 18.2 17.5438 18.1866 17.4807 18.1604C17.4176 18.1343 17.3602 18.096 17.3119 18.0477L13 13.7352L8.68819 18.0477C8.59062 18.1452 8.45829 18.2 8.32031 18.2C8.18233 18.2 8.05 18.1452 7.95243 18.0477C7.85486 17.9501 7.80005 17.8178 7.80005 17.6798C7.80005 17.5418 7.85486 17.4095 7.95243 17.3119L12.2649 13L7.95243 8.68819C7.85486 8.59062 7.80005 8.45829 7.80005 8.32031C7.80005 8.18233 7.85486 8.05 7.95243 7.95243C8.05 7.85486 8.18233 7.80005 8.32031 7.80005C8.45829 7.80005 8.59062 7.85486 8.68819 7.95243L13 12.2649L17.3119 7.95243C17.4095 7.85486 17.5418 7.80005 17.6798 7.80005C17.8178 7.80005 17.9501 7.85486 18.0477 7.95243C18.1452 8.05 18.2 8.18233 18.2 8.32031C18.2 8.45829 18.1452 8.59062 18.0477 8.68819L13.7352 13L18.0477 17.3119Z",
    fill: "#D3D7D9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseAsset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-asset.0fd8f05135e310a7c48a14195e0addeb.svg";